
import { defineComponent, ref, Ref } from 'vue';
import { formatUrls } from '@/common/utils';
import { sendLog, radarLog } from '@/common/radar';
import { MobilePageSource } from '@/constants/base';
import 'swiper/css/swiper.css';
import { getLlsidFromExptag } from '@/common/common-params';

export default defineComponent({
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    bizData: {
      type: Object,
      default: () => ({ pageSource: MobilePageSource.PwaForyou })
    }
  },
  setup(props, ctx) {
    const startPlayTime = ref(0)
    const videoComp:  Ref<any> = ref(null)

    const onClickVideo = (e: Event) => {
      ctx.emit('video-click', e)
    }

    const onWaiting = () => {
      ctx.emit('video-waiting')
    }

    const onPlaying = () => {
      ctx.emit('video-playing', props.index)
    }

    const onError = () => {
      radarLog({
        name: 'PWA_VIDEO_ERROR',
        event_type: 'click',
        category: 'KWAI_SHARE',
        message: `error url: ${props.item?.main_mv_urls[0]?.url}`,
        src: window.location.pathname
      })
    }

    const onEnded = () => {}

    const onPause = () => {
      const videoComp = getVideoEle()
      const playTime = videoComp?.getCurrentTime() || 0
      const duration = videoComp?.getDuration() || 0
      console.log('handlePause-->', props.index, playTime, duration)
      if(playTime > 0 && props.item.photo_id_str && duration > 0) {
        sendLog({
          type: 'click',
          name: 'PLAY_TIME_MOBILE',
          value: {
            photo_id: props.item.photo_id_str,
            author_id: props.item.user_id,
            play_time: playTime,
            photo_time: duration,
            if_error: 0,
            exp_tag: props?.item?.exp_tag,
            llsid: getLlsidFromExptag(props?.item?.exp_tag),
          }
        })
      }
      startPlayTime.value = new Date().getTime()
    }
    const getVideoEle = () => {
      return videoComp.value?.videoRef
    }

    const onVideoPlay = () => {
      startPlayTime.value = new Date().getTime()
    }

    return {
      onClickVideo,
      onWaiting,
      onPlaying,
      formatUrls,
      onError,
      onEnded,
      onPause,
      onVideoPlay,
      videoComp
    }
  }
})
